import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import { connect } from 'react-redux';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';

export class OutOfPocketPage extends Component {
  render() {
    const title = "What to know about paying out of pocket.";

    // The first paragraph is common, regardless of appt location.
    const paragraph1 = "Patients who are paying out of pocket must speak with a patient financial advocate (PFA) before your appointment request can be processed. The PFA will discuss an estimated cost for service, required deposit (if applicable) and your payment options.";

    const paragraph2 = (this.props.appointment.location.includes("Florida")) ?
      // Second paragraph for Florida locations
      "Please review your information on the following screen. Once your request is submitted, you can expect a call from a PFA within 24-48 hours." :
      // Second paragraph for Ohio and Nevada locations
      "Please review your information on the following screen. We will schedule your PFA appointment on a time and day that works for you.";


    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: 'button',
            id: "back",
            className: "btn--secondary",
            value: 'Back',
            onClick: () => {
              this.props.history.goBack();
            }
          },
          {
            type: 'button',
            id: "review",
            className: "btn--primary",
            value: 'Review my request',
            onClick: () => {
              this.props.history.push(nextPage());
            }
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
            <p>{paragraph1}</p>
            <p>{paragraph2}</p>
          </GridItem>
        </Grid>

        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

OutOfPocketPage.propTypes = {
  appointment: defaultState.appointmentProptype
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

// connects component to redux, and passes along the router
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OutOfPocketPage));
